$(document).ready(function() {
  var collectionName = $.trim($('.product__title').attr('data-collection'));

  var allowedCollections = [
    "Warmtekussen",
    "Warmtezitkussens",
    "Warmtedekens"
  ];


  if (allowedCollections.includes(collectionName) || window.location.pathname == '/pages/korting')  {

    var title = $('.template-product .product__title h1').text().split(' ');
    var title2 = $('.template-product .product__title h1').text().split(' ');

    title[1] = '<div class="bold-second-word">1+1&nbsp;' + title[1] + '</div>';
    title[0] = '<span class="hide_pleaf">' + title[0] + '</span>';

    $('.template-product .product__title h1').html(title.join(' '));
  }
  else {
    var title = $('.template-product .product__title h1').text().split(' ');
    title[0] = '<div class="bold-second-word">' + title[0] + '</div>';
    $('.template-product .product__title h1').html(title.join(' '));
  }

    $('.quetions_header').click(function() {
    $(this).nextUntil('.quetions_header').filter('.shopify_explorer_faq__item').slideToggle();
    $(this).toggleClass('active');
    });
    $('.quetions_header.data-1').click();

    $('.template-page-black-friday-sale .sticky_mainn').appendTo('main');
    function toggleDetailsAttribute() {
        if ($(window).width() > 767) {
            $('.template-page-black-friday-sale .Desktop_notopen details').attr('open', true);
        }
    }
    toggleDetailsAttribute();
    let resizeTimeout;
    $(window).resize(function () {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(toggleDetailsAttribute, 100);
    });
  
    $(".questionmark").on("click", function(event) {
    event.stopPropagation(); 
    var $hoverElement = $(this).find('.questionmark_hover'); 
    $('.questionmark_hover').not($hoverElement).hide(); 
    $hoverElement.toggle(); 
    });
    $(document).on("click", function() {
    $('.questionmark_hover').hide();
    });
    if (window.matchMedia("(max-width: 767px)").matches) {
      interval = setInterval(function(){
      if($('.swiper-wrappers.slider_active .product-carousel__product').length >=2){
      $('.swiper-wrappers.slider_active').slick({
      arrows:  false,
      centerPadding: "0px",
      speed:500,
      fade:true,
      dots: true,
      slidesToShow: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000
      });
      }
      if($('.swiper-wrappers.slider_active').hasClass('slick-initialized')){
      clearInterval(interval);
      }
      }, 1000);
      }
    $('.read-more_btn').on('click', function() {
              var $this = $(this);
              $this.toggleClass('active');
              if ($this.hasClass('active')) {
                  $this.find('span').text('Lees minder');
              } else {
                  $this.find('span').text('Lees meer');
              }
          });

    $('.readmore_readless_btn').click(function() {
        $('.small-description.product__description').toggleClass('active');
         $('.full-description.product__description').toggleClass('active');
        if(!$('.full-description.product__description').hasClass('active')){
         $('html, body').animate({
            scrollTop: $('.small-description').offset().top
        },10);
        }

    });

    $('.drawer .cart-drawer__overlay').click(function () {
        $('.drawer button.drawer__close.modal__close-button.modal-close-button').trigger('click');
    });

    var lastScrollTop = 0;
    $(window).scroll(function(event){
              var st = $(this).scrollTop();
              if (st > lastScrollTop){
                  $('.annoucement-bar-new').removeClass('scrollingdowns');
              } else {
                  $('.annoucement-bar-new').addClass('scrollingdowns');
              }
              lastScrollTop = st;
          });

    var element = $('.stick-cart-button');
    var target = $('.product-form__buttons');
    $(window).scroll(function() {
        var targetVisible = isElementInView(target);
        var scrollDistance = $(window).width() < 767 ? 2100 : 2100;

        if (targetVisible) {
           // element.removeClass('Stick_Bar');
        } else if ($(this).scrollTop() > scrollDistance) {
            element.addClass('Stick_Bar');
        } else {
            element.removeClass('Stick_Bar');
        }
    });
    function isElementInView(element) {
        var elementTop = element.offset().top;
        var elementBottom = elementTop + element.outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    $('.drawer .cart-drawer__overlay').click(function () {
        $('.drawer button.drawer__close.modal__close-button.modal-close-button').trigger('click');
    });

    var lastScrollTop = 0;
    $(window).scroll(function(event){
              var st = $(this).scrollTop();
              if (st > lastScrollTop){
                  $('.annoucement-bar-new').removeClass('scrollingdowns');
              } else {
                  $('.annoucement-bar-new').addClass('scrollingdowns');
              }
              lastScrollTop = st;
          });

});

    $('.Drawer-navigation-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: true,
        prevArrow: '<div class="prev-icon"><i class="fa-solid fa-chevron-left"></i></div>',
        nextArrow: '<div class="next-icon"><i class="fa-solid fa-chevron-right"></i></div>',
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                }
            }
        ]
    });
    $('.menu-drawer-container .header__icon--menu').on('click', function(){
    $('.Drawer-navigation-slider .next-icon.slick-arrow').click();
    });
    $(document).on('click','.cart_upsell .details_upsell  .add_to_cart',function(){
      $('.spinner-iconss').css("display", "block");
      $('.c-upsell.js-upsell').css("display", "none");
      $('.drawer').removeClass('is-empty');
      var cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
      $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
              quantity: 1,
              id: $(this).attr('idd'),
              sections: cart.getSectionsToRender().map((section) => section.id),
              sections_url: window.location.pathname,
          },
          dataType: 'json',
          success: function(response) {
            $('.spinner-iconss').css("display", "none");  $('.c-upsell.js-upsell').css("display", "block");
            cart.renderContents(response);
              setTimeout(function() {
              $('.slideshow-container a.next').click()
              $('.slideshow-container-mobile a.next').click()
              }, 500);
          },
          error: function() {
              console.log('error');
          }
      });
  });
    $(document).on('click','.Drawer-navigation-slider .details_bestseller button',function(event){
                $('.drawer').removeClass('is-empty');
                var cart =
                document.querySelector("cart-notification") ||
                document.querySelector("cart-drawer");
                event.preventDefault();
                $.ajax({
                type: 'GET',
                url: '/cart/add.js',
                data: {
                      quantity: 1,
                      id: $(this).attr('id'),
                      sections: cart.getSectionsToRender().map((section) => section.id),
                      sections_url: window.location.pathname,
                  },
                dataType: 'json',
                success: function (response){
                cart.renderContents(response);
                setTimeout(function() {
                $('.slideshow-container a.next').click()
                $('.slideshow-container-mobile a.next').click()
                }, 1000);
                },
                error: function () {
                console.log('error');
                }
                });
                });

    let slideIndexnew = 1;
    showSlides(slideIndexnew);
    function plusSlides(n) {
      showSlides(slideIndexnew += n);
    }
    function showSlides(n) {
        let slides = document.getElementsByClassName("mySlides");
        if(slides.length > 0){
        if (n > slides.length) {
          slideIndexnew = 1;
        } else if (n < 1) {
          slideIndexnew = slides.length;
        }
        for (let i = 0; i < slides.length; i++) {
          slides[i].style.display = "none";
        }
        let firstIndex = slideIndexnew - 1;
        let secondIndex = (firstIndex + 1) % slides.length;
        slides[firstIndex].style.display = "block";
        slides[secondIndex].style.display = "block";
        } else{
      $('.prev').hide();
      $('.next').hide();
      $('.upsell p.upsell-header').hide();
      }
      }

    document.querySelectorAll('.c-faqs__item details').forEach((nestedAccordion) => {
                         nestedAccordion.removeAttribute('open');
                       });
    document.querySelectorAll('.accordion details').forEach((accordion) => {
                         accordion.addEventListener('toggle', function() {
                           if (this.closest('.c-faqs__item') === null && this.open) {
                             document.querySelectorAll('.accordion details[open]').forEach((openAccordion) => {
                               if (openAccordion !== this) {
                                 openAccordion.removeAttribute('open');
                               }
                             });
                             this.scrollIntoView({ behavior: 'smooth', block: 'start' });
                           }
                           if (this.closest('.c-faqs__item') !== null && this.open) {
                             this.closest('.c-faqs__items').querySelectorAll('.c-faqs__item details[open]').forEach((openNested) => {
                               if (openNested !== this) {
                                 openNested.removeAttribute('open');
                               }
                             });
                           }
                         });
                       });

    $(document).on('change', '#itemsvarints', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var qty = $(this).parents('.quantity-with-selector').find('input.quantity__input').val();
    var newVariantId = $(this).val();
    var itemKey = $(this).attr('itemkey');
    console.log(qty,newVariantId,itemKey)
    $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
    quantity: 0,
    id: itemKey
    },
    dataType: 'json',
    success: function(cart) {
    console.log('Product removed successfully');
    $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
    id: newVariantId,
    quantity: qty
    },
    dataType: 'json',
    success: function(cart) {
    $('form#CartDrawer-Form').load(location.href + "form.cart-drawer__form .drawer__contents", function() { });
    $('p.totals__subtotal-value.original_total_price').text('€'+cart.final_line_price/100)
    if(cart.final_line_price > cart.discounted_price){
    $('p.totals__subtotal-value.total_price').text('€'+cart.discounted_price/100)
    }else{
    $('p.totals__subtotal-value.total_price').text('€'+cart.final_line_price/100)
    }
    },
    error: function(error) {
    console.error('Error adding new product', error);
    }
    });
    },
    error: function(error) {
    console.error('Error removing product', error);
    }
    });
    });

    function toggleClassBasedOnWidth() {
    if(document.querySelector('.product-logos.friday-deal .logos-sec')){
    if (window.innerWidth <= 1024) {
    if (!$('.product-logos.friday-deal .logos-sec.active-slider').hasClass('slick-initialized')) {
    $('.product-logos.friday-deal .logos-sec.active-slider').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1
    });
    }}
      else{
        if ($('.product-logos.friday-deal .logos-sec.active-slider').hasClass('slick-initialized')) {
          $('.product-logos.friday-deal .logos-sec.active-slider').slick('unslick');
        }
      }
    }
    }
    toggleClassBasedOnWidth();
    window.addEventListener('resize', toggleClassBasedOnWidth);
    
    $('.gallery_main').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: '.thumnail_list',
        fade: true,
        prevArrow: $('.swiper-btn--prev'),
        nextArrow: $('.swiper-btn--next'),
    });
    $('.thumnail_list').slick({
        slidesToShow: 4,
        slidesToScroll: 2,
        dots: false,
        arrows: false,
        centerMode: false,
        focusOnSelect: true,
        variableWidth: true
    });
    $('.thumnail_list').on('click', '.slick-slide', function(event) {
        var index = $(this).data('slick-index');
        $('.gallery_main').slick('slickGoTo', index);
    });
    $('.gallery_main').magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0,1]
            },
           zoom: {
        enabled: true,
        duration: 300,
        easing: 'ease-in-out',
        opener: function(openerElement) {
            return openerElement.is('img') ? openerElement : openerElement.find('img');
        }
    },
    callbacks: {
        elementParse: function(item) {
            console.log($(item.el[0]).hasClass('magnify-video-product'));
            if ($(item.el[0]).hasClass('magnify-video-product') == true) {
                item.type = 'iframe';
                item.iframe = {
                    patterns: {
                        youtube: {
                            index: 'youtube.com/',
                            id: 'v=',
                            src: '//www.youtube.com/embed/%id%?autoplay=1&muted=0&loop=1&playsinline=1'
                        },
                        vimeo: {
                            index: 'vimeo.com/',
                            id: '/',
                            src: '//player.vimeo.com/video/%id%?autoplay=1&rel=0'
                        },
                        gmaps: {
                            index: '//maps.google.',
                            src: '%id%&output=embed'
                        }
                    }
                };
            } else {
                item.type = 'image';
                item.tLoading = 'Loading image #%curr%...';
                item.mainClass = 'mfp-img-mobile';
                item.image = {
                    tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
                };
            }
        }
    }
          });
    $('.gallery_main').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.gallery-img-holder video').each(function () {
                this.pause();
            });
            var nextSlideVideo = $('video', slick.$slides[nextSlide])[0];
            if (nextSlideVideo) {
                nextSlideVideo.play();
            }
        });

    function daateupdate() {
            var currentDay = new Date().getDay();
          if (currentDay === 5) { 
              var text2 = document.getElementById('text2');
              if (text2) text2.style.display = 'block'; 
          } else if (currentDay === 6) { 
              var text3 = document.getElementById('text3');
              if (text3) text3.style.display = 'block';
          } else {
              var text1 = document.getElementById('text1');
              if (text1) text1.style.display = 'block';
          }
          }
    daateupdate();

// barba js
    $(document).on('click', '.a_tagg', function(event){
          handleCustomDivClicks(event)
      })

    window.before_url = window.location.pathname + window.location.search;
    function handleCustomDivClicks(event) {
        const div = event.target.closest('.a_tagg');
        if (div) {
            event.preventDefault();
            const href = div.getAttribute('href');
            barba.go(href).then(() => {
                   console.log("Manually triggered Barba transition for the section",event);
            });
        }
    }

    barba.init({
          transitions: [{
              name: 'opacity-transition',
              before(data) {
                  console.log('Before transition');
                $('.template-page-black-friday-sale .sticky_mainn').remove()
              },
              leave(data) {
                  console.log('Leaving transition');
              },
              enter(data) {
                  console.log("Entering transition");
                  var r = data.trigger;
              },
              after(data) {
                var r = data;
                
          var element = $('.stick-cart-button');
          var target = $('.product-form__buttons');
          $(window).scroll(function() {
              var targetVisible = isElementInView(target);
              var scrollDistance = $(window).width() < 767 ? 700 : 500;

              if (targetVisible) {
                  element.removeClass('Stick_Bar');
              } else if ($(this).scrollTop() > scrollDistance) {
                  element.addClass('Stick_Bar');
              } else {
                  element.removeClass('Stick_Bar');
              }
          });
          function isElementInView(element) {
              var elementTop = element.offset().top;
              var elementBottom = elementTop + element.outerHeight();
              var viewportTop = $(window).scrollTop();
              var viewportBottom = viewportTop + $(window).height();
              return elementBottom > viewportTop && elementTop < viewportBottom;
          }
                    window.history.pushState({}, "", window.before_url);
                    toggleClassBasedOnWidth();
                    daateupdate();
                    var title = $('.product__title_sticky h1').text().split(' ');
                    var title2 = $('.product__title_sticky h1').text().split(' ');
                    title[1] = '<div class="bold-second-word">1+1&nbsp;' + title[1] + '</div>';
                    title[0] = '<span class="hide_pleaf">' + title[0] + '</span>';
                    $('.product__title_sticky h1').html(title.join(' '));
                    var title = $('.template-product .product__title h1').text().split(' ');
                    var title2 = $('.template-product .product__title h1').text().split(' ');
                    title[1] = '<div class="bold-second-word">1+1&nbsp;' + title[1] + '</div>';
                    title[0] = '<span class="hide_pleaf">' + title[0] + '</span>';
                    $('.template-product .product__title h1').html(title.join(' '));
                  $('.gallery_main').slick({
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      arrows: true,
                      asNavFor: '.thumnail_list',
                      fade: true,
                      prevArrow: $('.swiper-btn--prev'),
                      nextArrow: $('.swiper-btn--next'),
                  });
                  $('.thumnail_list').slick({
                      slidesToShow: 4,
                      slidesToScroll: 2,
                      dots: false,
                      arrows: false,
                      centerMode: false,
                      focusOnSelect: true,
                      variableWidth: true
                  });
                  $('.thumnail_list').on('click', '.slick-slide', function(event) {
                      var index = $(this).data('slick-index');
                      $('.gallery_main').slick('slickGoTo', index);
                  });
                  $('.gallery_main').magnificPopup({
                              delegate: 'a',
                              type: 'image',
                              gallery: {
                              enabled: true,
                              navigateByImgClick: true,
                              preload: [0,1]
                              },
                             zoom: {
                              enabled: true,
                              duration: 300,
                              easing: 'ease-in-out',
                              opener: function(openerElement) {
                                  return openerElement.is('img') ? openerElement : openerElement.find('img');
                              }
                          },
                          callbacks: {
                              elementParse: function(item) {
                                  console.log($(item.el[0]).hasClass('magnify-video-product'));
                                  if ($(item.el[0]).hasClass('magnify-video-product') == true) {
                                      item.type = 'iframe';
                                      item.iframe = {
                                          patterns: {
                                              youtube: {
                                                  index: 'youtube.com/',
                                                  id: 'v=',
                                                  src: '//www.youtube.com/embed/%id%?autoplay=1&muted=0&loop=1&playsinline=1'
                                              },
                                              vimeo: {
                                                  index: 'vimeo.com/',
                                                  id: '/',
                                                  src: '//player.vimeo.com/video/%id%?autoplay=1&rel=0'
                                              },
                                              gmaps: {
                                                  index: '//maps.google.',
                                                  src: '%id%&output=embed'
                                              }
                                          }
                                      };
                                  } else {
                                      item.type = 'image';
                                      item.tLoading = 'Loading image #%curr%...';
                                      item.mainClass = 'mfp-img-mobile';
                                      item.image = {
                                          tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
                                      };
                                  }
                              }
                          }
                        });

                        $('.gallery_main').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                            $('.gallery-img-holder video').each(function () {
                                this.pause();
                            });
                            var nextSlideVideo = $('video', slick.$slides[nextSlide])[0];
                            if (nextSlideVideo) {
                                nextSlideVideo.play();
                            }
                        });
                    $('.template-page-black-friday-sale .sticky_mainn').appendTo('main');
              }
          }],
          // Define the container for content updates (ensure it's scoped to the section)
          views: [
              {
                  namespace: 'product',
                  beforeEnter() {
                      console.log("Product page transition starting");
                  },
                  afterEnter() {
                      console.log("Product page transition completed",data);
                  }
              }
          ]
      });
// 
 